exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-channel__share-container__2vZmS{display:-ms-flexbox;display:flex;position:relative;color:-wix-colors-buttonsAndLinksColor-80}.share-channel__share-container__2vZmS:hover{color:-wix-colors-buttonsAndLinksColor-100}.share-channel__share-container__2vZmS:hover .share-channel__share-buttons__bMm5z{transition:opacity .3s ease .15s,margin .3s;opacity:1;margin-left:0}.share-channel__share-container__2vZmS:hover .share-channel__share__2UXlw{opacity:.5}.share-channel__share__2UXlw{cursor:pointer;font-size:13px;height:13px}.share-channel__share-buttons__bMm5z{color:-wix-colors-buttonsAndLinksColor-100;display:-ms-flexbox;display:flex;-ms-flex-line-pack:justify;align-content:space-between;width:110px;height:13px;padding-right:18px;margin-left:-110px;opacity:0;transition-property:opacity,margin;transition-duration:.3s;transition-delay:.5s}.share-channel__share-button__2oGPJ{cursor:pointer;font-size:13px}.share-channel__facebook__-WkQU:hover{color:#3b5999}.share-channel__twitter__N9wMI:hover{color:#55acee}.share-channel__pinterest__31poE:hover{color:#bd081c}.share-channel__tumblr__1iIpB:hover{color:#34465d}", ""]);

// exports
exports.locals = {
	"share-container": "share-channel__share-container__2vZmS",
	"shareContainer": "share-channel__share-container__2vZmS",
	"share-buttons": "share-channel__share-buttons__bMm5z",
	"shareButtons": "share-channel__share-buttons__bMm5z",
	"share": "share-channel__share__2UXlw",
	"share-button": "share-channel__share-button__2oGPJ",
	"shareButton": "share-channel__share-button__2oGPJ",
	"facebook": "share-channel__facebook__-WkQU",
	"twitter": "share-channel__twitter__N9wMI",
	"pinterest": "share-channel__pinterest__31poE",
	"tumblr": "share-channel__tumblr__1iIpB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/share-channel/share-channel.styl
// module id = 2926
// module chunks = 1